import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { API_URL } from "./token.service";

import "rxjs/add/operator/filter";

@Injectable()
export class _NotificationService {
  constructor(private http: HttpClient) {}

  getList() {
    return this.http.get(`${API_URL}/notifications`).toPromise();
  }

  update(id: number) {
    return this.http.put(`${API_URL}/notifications/${id}`, {}).toPromise();
  }

  delete(id: number) {
    return this.http.delete(`${API_URL}/notifications/${id}`).toPromise();
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/services/notification.service.ts